// Seeded random numbers: the city is generated from one fixed seed so it looks the same on every load.

// seeded RNG so the city looks the same on every reload
let seed = 7;
export const rnd = () => {
  seed = (seed + 0x6d2b79f5) | 0;
  let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
  t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};
export const rr = (a, b) => a + rnd() * (b - a),
  pick = (a) => a[Math.floor(rnd() * a.length)];
